// Copyright (c) 2018 Swashata Ghosh <swashata@wpquark.com>
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT

// Import the icons
import '../assets/fipicon/style.css';

// Import the styles
import '../scss/base.scss';
